export enum Theme {
  Red = 0,
  White = 1,
  Black = 2,
}

export enum ViewMode {
  //
  // Summary:
  //     Live site mode.
  LiveSite = 0,
  //
  // Summary:
  //     Preview mode.
  Preview = 2,
  //
  // Summary:
  //     Edit mode - content editing.
  Edit = 3,
  //
  // Summary:
  //     Edit mode - content editing (editing disabled).
  EditDisabled = 4,
  //
  // Summary:
  //     Edit mode - not current page.
  EditNotCurrent = 5,
  //
  // Summary:
  //     Edit mode with disabled controls - when not authorized or cannot edit.
  Design = 6,
  //
  // Summary:
  //     Design mode with disabled controls - for portal engine pages.
  DesignDisabled = 7,
  //
  // Summary:
  //     Edit form mode - for portal engine pages.
  EditForm = 8,
  //
  // Summary:
  //     Unknown / does not matter
  Unknown = 9,
  //
  // Summary:
  //     User widgets mode.
  UserWidgets = 12,
  //
  // Summary:
  //     User widgets mode with disabled functionality (for preview mode).
  UserWidgetsDisabled = 13,
  //
  // Summary:
  //     Group widgets mode.
  GroupWidgets = 14,
  //
  // Summary:
  //     Dashboard widgets mode.
  DashboardWidgets = 15,
  //
  // Summary:
  //     On-Site edit mode
  EditLive = 18,
  //
  // Summary:
  //     Listing mode.
  Listing = 20,
  //
  // Summary:
  //     Section edit mode.
  SectionEdit = 21,
  //
  // Summary:
  //     UI Page
  UI = 22,
  //
  // Summary:
  //     Design mode for web parts
  DesignWebPart = 23,
}

export enum MediaType {
  Image = 0,
  Video = 1,
}

export enum BeneluxBlitzCountry {
  None = 0,
  Belgium = 1,
  Luxembourg = 2,
  Netherlands = 3,
  Denmark = 4,
  Norway = 5,
  Estonia = 6,
  Latvia = 7,
  Sweden = 8,
  Finland = 9,
  Hungary = 10,
}

export enum ProductDetailDownloadType {
  SpareParts = 0,
  DataSheet = 1,
  FactTag = 2,
  Guide = 3,
  SoftwareUpdate = 4,
  Certificate = 5,
  SizeGuide = 6,
}

export enum FileUploadTypes {
  Doc = '.doc',
  DocX = '.docx',
  Pdf = '.pdf',
  Gif = '.gif',
  Jpg = '.jpg',
  Jpeg = '.jpeg',
  Png = '.png',
}

export enum FilterFacetLayout {
  Buttons = 0,
  Colours = 1,
  Thumbnails = 2,
}

export enum TeesterTrackingEvent {
  ProductPageView = 1,
}
